import React, { useState } from "react";
import { useAnalyticsApi } from "react-use-analytics-api";
import {
  AnalyticsDashboard,
  SessionsByDateChart,
} from "react-analytics-charts";
import { Tooltip, Box } from "@mui/material/";

import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import { useTranslation } from "react-i18next";

const Sessions = ({ dashboard }) => {
  const { t, i18n } = useTranslation();
  const [period, setPeriod] = useState(30);

  const { ready, gapi, authorized, error } = useAnalyticsApi();
  let clientId =
    "568824200639-58enea0l8cr2arus6f1hech205ibqvci.apps.googleusercontent.com";
  let viewId = "261404142";

  return (
    <Box>
      {!dashboard && (
        <>
          <Box sx={{ pt: 3, pb: 1, fontSize: "14px" }}>
            <span style={{ fontWeight: "bold", fontSize: "16px" }}>
              {t("Session")}{" "}
            </span>
            <span className="pink_link">
              <a
                target="_blank"
                rel="noreferrer"
                href="https://support.google.com/analytics/answer/6086069?hl=en"
                style={{ fontSize: "15px" }}
              >
                {t("Doc")}
              </a>
            </span>
          </Box>
          <Box sx={{ pb: 1, color: "gray" }}>
            {t(
              "Session is the period of time a user is active on your site or app. By default, if a user is inactive for 30 minutes or more, any future activity is attributed to a new session. Users that leave your site and return within 30 minutes are counted as part of the original session."
            )}
          </Box>
          <FormControl sx={{ mt: 2, width: 300 }}>
            <InputLabel id="demo-simple-select-label">
              {t("Set Period")}
            </InputLabel>
            <Select
              labelId="demo-simple-select-label"
              id="demo-simple-select"
              value={period}
              label="Period"
              onChange={(e) => setPeriod(e.target.value)}
              sx={{ width: 300 }}
            >
              <MenuItem value={30}>1 {t("Month")}</MenuItem>
              <MenuItem value={60}>3 {t("Month")}</MenuItem>
              <MenuItem value={180}>6 {t("Month")}</MenuItem>
              <MenuItem value={270}>9 {t("Month")}</MenuItem>
            </Select>
          </FormControl>
        </>
      )}

      <AnalyticsDashboard
        authOptions={{ clientId }}
        renderCharts={(gapi, viewId) => {
          return (
            <SessionsByDateChart
              gapi={gapi}
              viewId={viewId}
              days={period}
              showPageViews
              showUsers
            />
          );
        }}
      />
    </Box>
  );
};

export default Sessions;
